import {StoreRegionData} from '../utils/storeGeoLocator';

export enum Currency {
  NOK = 'NOK',
  SEK = 'SEK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NZD = 'NZD',
  USD = 'USD',
  CAD = 'CAD',
  AUD = 'AUD',
  CHF = 'CHF',
}

export enum Country {
  NO = 'NO',
  SE = 'SE',
  FI = 'FI',
  DE = 'DE',
  NL = 'NL',
  BE = 'BE',
  GB = 'GB',
  IE = 'IE',
  FR = 'FR',
  ES = 'ES',
  PT = 'PT',
  DK = 'DK',
  HR = 'HR',
  NZ = 'NZ',
  GR = 'GR',
  SL = 'SL',
  US = 'US',
  CA = 'CA',
  TR = 'TR',
  AU = 'AU',
  CH = 'CH',
}

export const REGION_CURRENCY_MAP = {
  NO: Currency.NOK,
  SE: Currency.SEK,
  DK: Currency.DKK,
  EU: Currency.EUR,
  GB: Currency.GBP,
  NZ: Currency.NZD,
  US: Currency.USD,
  CA: Currency.CAD,
  TR: Currency.USD,
  AU: Currency.AUD,
  CH: Currency.CHF,
} as const;

export const REGION_NAMES = {
  NO: 'Norway',
  SE: 'Sweden',
  DK: 'Denmark',
  EU: 'E.U.',
  GB: 'Great Britain',
  NZ: 'New Zealand',
  US: 'United States',
  CA: 'Canada',
  TR: 'Turkey',
  AU: 'Australia',
  CH: 'Switzerland',
};

export const REGION_CURRENCY_FALLBACK = [
  {region: 'EU', currency: REGION_CURRENCY_MAP.EU},
] as StoreRegionData[];

export const CURRENCY_SYMBOL_MAP = {
  [Currency.NOK]: {
    prefix: null,
    suffix: 'kr',
  },
  [Currency.SEK]: {
    prefix: null,
    suffix: 'kr',
  },
  [Currency.DKK]: {
    prefix: null,
    suffix: 'kr',
  },
  [Currency.EUR]: {
    prefix: '€',
    suffix: null,
  },
  [Currency.GBP]: {
    prefix: '£',
    suffix: null,
  },
  [Currency.NZD]: {
    prefix: 'NZ$',
    suffix: null,
  },
  [Currency.USD]: {
    prefix: '$',
    suffix: null,
  },
  [Currency.CAD]: {
    prefix: 'CA$',
    suffix: null,
  },
  [Currency.AUD]: {
    prefix: 'AU$',
    suffix: null,
  },
  [Currency.CHF]: {
    prefix: null,
    suffix: 'CHF',
  },
} as const;

export const SHIPPING_COUNTRIES: Country[] = Object.values(Country);

type ShippingMap = {
  [key: string]: {
    min: number;
    max: number;
  };
};

export const REGION_SHIPPING_MAP: ShippingMap = {
  NO: {
    min: 3,
    max: 6,
  },
  SE: {
    min: 1,
    max: 4,
  },
  DK: {
    min: 2,
    max: 5,
  },
  EU: {
    min: 2,
    max: 6,
  },
  CH: {
    min: 2,
    max: 6,
  },
  HR: {
    min: 3,
    max: 7,
  },
  GB: {
    min: 3,
    max: 7,
  },
  NZ: {
    min: 6,
    max: 12,
  },
  AU: {
    min: 6,
    max: 12,
  },
  US: {
    min: 4,
    max: 10,
  },
  TR: {
    min: 4,
    max: 10,
  },
  CA: {
    min: 4,
    max: 10,
  },
} as const;
